import { Object } from "es6-shim";

/* eslint-disable */

var platform = new H.service.Platform({
  app_id: "QAMC1KyzMPBmwVKoWYEt",
  app_code: "VjikBbiSnHPORJnrFZVkNg",
  useHTTPS: true
});

var geocoder = platform.getGeocodingService();
var map;
var ui;
const byCategory = {
  Sport: "#ffbed2",
  Languages: "#94ccff",
  "Performing Arts": "#ff9191",
  Arts: "#a3d289",
  Swimming: "#d594da",
  Technology: "#ffc28b",
  Cooking: "#c28f9f"
};

const markersOnMap = {
  currentMarkers: [],
  markerGroup: null,
  alreadySelected: [],
  removeOnLeave: true,
  selectedMarkerGroup: null,
  fullSelectionMode: false
};

function findNearestMarker(coords) {
  var minDist = 10000000,
    markerDist,
    marker,
    // get all objects added to the map
    objects = markersOnMap.markerGroup.getObjects(),
    len = markersOnMap.markerGroup.getObjects().length,
    i;

  // iterate over objects and calculate distance between them
  for (i = 0; i < len; i += 1) {
    markerDist = objects[i].getPosition().distance(coords);
    if (markerDist < minDist) {
      minDist = markerDist;
      marker = objects[i];
    }
  }
  return marker ? marker : markersOnMap.markerGroup.getObjects()[0];
}

export function setCenter(coords) {
  map.setCenter(new H.geo.Point(coords.lat, coords.lng));
}
export function initMap(container, markerSelected, onFullSelect, isMobile) {
  var targetElement = document.getElementById(container);
  // Get default map types from the platform object:
  var defaultLayers = platform.createDefaultLayers();

  //-36.8892 174.7665
  // Instantiate the map:
  map = new H.Map(targetElement, defaultLayers.normal.map, {
    zoom: 11,
    center: { lat: -36.8892, lng: 174.7665 } //-36.87684:174.63398
  });
  var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
  ui = H.ui.UI.createDefault(map, defaultLayers);
  var group = new H.map.Group();
  map.addObject(group);
  var selectedGroup = new H.map.Group();
  map.addObject(selectedGroup);
  markersOnMap.selectedMarkerGroup = selectedGroup;
  // map.addEventListener(
  //   "pointermove",
  //   function(evt) {
  //     if (event.target instanceof H.map.Marker) {
  //       markerSelected(evt.target.getData(), "map");
  //     }
  //   },
  //   false
  // );
  map.addEventListener(
    "tap",
    function(event) {
      if (event.target instanceof H.map.Marker) {
        if (event.target.getData().filter) {
          markersOnMap.onFullSelect(event.target.getData(), "map");
        }
      } else {
        var coords = map.screenToGeo(
          event.currentPointer.viewportX,
          event.currentPointer.viewportY
        );
        var m = findNearestMarker(coords);
        if (m) {
          markersOnMap.onFullSelect(m.getData(), "map");
        }
      }
    },
    false
  );
  map.addEventListener(
    "pointermove",
    function(event) {
      if (markersOnMap.isMobile) {
        if (event.target instanceof H.map.Marker) {
          map.getViewPort().element.style.cursor = "pointer";
        } else {
          map.getViewPort().element.style.cursor = "auto";
        }
        return;
      }
      if (markersOnMap.fullSelectionMode) {
        return;
      }
      if (event.target instanceof H.map.Marker) {
        map.getViewPort().element.style.cursor = "pointer";
        const array1 = markersOnMap.alreadySelected;
        const array2 = event.target.getData();
        if (
          array1.length === array2.length &&
          array1.sort().every(function(value, index) {
            return value === array2.sort()[index];
          })
        ) {
        } else {
          if (event.target.getData().filter) {
            markersOnMap.markerSelected(event.target.getData(), "map");
          }
        }
      } else {
        map.getViewPort().element.style.cursor = "auto";
        if (markersOnMap.alreadySelected.length) {
          markersOnMap.alreadySelected = [];
          markersOnMap.markerSelected(null, "map");
        }
      }
    },
    false
  );
  // map.addEventListener(
  //   "pointerenter",
  //   function(event) {
  //     const array1 = markersOnMap.alreadySelected;
  //     const array2 = event.target.getData();
  //     if (
  //       array1.length === array2.length &&
  //       array1.sort().every(function(value, index) {
  //         return value === array2.sort()[index];
  //       })
  //     ) {
  //     } else {
  //       markersOnMap.markerSelected(event.target.getData(), "map");
  //     }
  //   },
  //   false
  // );
  // marker.addEventListener(
  //   "pointerleave",
  //   function(event) {
  //     markersOnMap.markerSelected(null, "map");
  //   },
  //   false
  // );

  markersOnMap.markerGroup = group;
  markersOnMap.markerSelected = markerSelected;
  markersOnMap.onFullSelect = onFullSelect;
  markersOnMap.isMobile = isMobile;

  var mapSettings = ui.getControl("mapsettings");
  var zoom = ui.getControl("zoom");
  var scalebar = ui.getControl("scalebar");

  if (!isMobile) {
    zoom.setAlignment("top-center");
    scalebar.setAlignment("top-left");
    mapSettings.setAlignment("top-center");
  } else {
    zoom.setAlignment("top-right");
    scalebar.setAlignment("top-left");
    mapSettings.setAlignment("top-right");
  }
}

export function setMode(full) {
  if (full !== markersOnMap.fullSelectionMode) {
    markersOnMap.needCenter = true;
  }
  markersOnMap.fullSelectionMode = full;
}

export function setSelectedMarker(obj, center) {
  markersOnMap.selectedMarkerGroup.removeAll();
  markersOnMap.alreadySelected = obj || [];
  markersOnMap.currentMarkers = [];
  let lats = 0;
  let lngs = 0;
  const markersPerPlace = {};
  let count = 0;
  obj.forEach(s => {
    markersPerPlace[s.placeName] = markersPerPlace[s.placeName] || [];
    markersPerPlace[s.placeName].push(s);
  });
  Object.keys(markersPerPlace).forEach(p => {
    const s = markersPerPlace[p][0];
    const m = {
      id: s.id,
      lng: s.location.coordinates[0],
      lat: s.location.coordinates[1]
    };
    const dClasses = [];
    markersPerPlace[p].forEach(m => {
      if (dClasses.indexOf(m.name.replace(/Copy/g, "").trim()) < 0) {
        dClasses.push(m.name.replace(/Copy/g, "").trim());
      }
    });
    if (true) {
      //!markersOnMap.isMobile
      var bubble = `<div class='main-info-bubble'><div class="bubble-pointer">
      <div class="bubble-pointer-one"></div><div class="bubble-pointer-two"></div></div>
      <div class='info-bubble'><div class="info-bubble-place">${
        s.placeName
      }</div> <div class='info-bubble-name'>${s.name}</div>
      <div class='${
        dClasses.length > 1 ? "info-bubble-multiple" : "info-bubble-single"
      }'>+${dClasses.length - 1} More</div>
      <div class='info-bubble-footer'> 
      <div class='info-bubble-price'> ${
        s.price ? (s.price.indexOf("$") >= 0 ? s.price : "$" + s.price) : ""
      }</div> <div class='info-bubble-age'>Ages ${s.ageFrom}${
        s.ageTo > 100 ? "+" : "-" + s.ageTo
      }</div><div class='info-bubble-banner' style='background-color:${
        byCategory[s.category]
      };'/></div></div></div>`;
      var domElement = document.createElement("div");
      domElement.innerHTML = bubble;
      var domIcon = new H.map.DomIcon(domElement);
      var bearsMarker = new H.map.DomMarker(m, {
        icon: domIcon
      });
      markersOnMap.selectedMarkerGroup.addObject(bearsMarker);
    }
    lats = lats + m.lat;
    lngs = lngs + m.lng;
    count += 1;
  });
  if (lats) {
    map.setCenter(new H.geo.Point(lats / count, lngs / count));
  }
}

export function setMarkers(objs, fullSelected) {
  if (!markersOnMap.markerGroup) {
    return;
  }
  // if (markersOnMap.fullSelectionMode) {
  //   return;
  // }
  const current = markersOnMap.markerGroup.getObjects();
  let lats = 0;
  let lngs = 0;
  let count = 0;
  //we need to group by location, maybe place name?
  const markersPerPlace = {};
  if (fullSelected && fullSelected.length) {
    objs = fullSelected;
  }
  objs.forEach(s => {
    markersPerPlace[s.placeName] = markersPerPlace[s.placeName] || [];
    markersPerPlace[s.placeName].push(s);
  });
  const fullSelectedIds = (fullSelected || []).map(f => f.id);
  const found = [];
  Object.keys(markersPerPlace).forEach(p => {
    const s = markersPerPlace[p][0];
    const ids = markersPerPlace[p].map(m => m.id);
    const sel = ids.filter(i => fullSelectedIds.indexOf(i) >= 0)[0];
    if (s.location) {
      const o = {
        id: s.id,
        lng: s.location.coordinates[0],
        lat: s.location.coordinates[1]
      };

      if (
        !sel &&
        s.id !== markersOnMap.selected &&
        current.filter(i => i.getData()[0].id === s.id)[0]
      ) {
        found.push(s.id);
        return;
      }
      lats = lats + o.lat;
      lngs = lngs + o.lng;
      count += 1;
      if (sel) {
        markersOnMap.selected = sel;
      }
      var svgMarkup = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="32" height="32" viewBox="0 0 263.335 263.335" style="enable-background:new 0 0 263.335 263.335;" xml:space="preserve">
      <g>
          <g xmlns="http://www.w3.org/2000/svg">
              <path d="M40.479,159.021c21.032,39.992,49.879,74.22,85.732,101.756c0.656,0.747,1.473,1.382,2.394,1.839   c0.838-0.396,1.57-0.962,2.178-1.647c80.218-61.433,95.861-125.824,96.44-128.34c2.366-9.017,3.57-18.055,3.57-26.864    C237.389,47.429,189.957,0,131.665,0C73.369,0,25.946,47.424,25.946,105.723c0,8.636,1.148,17.469,3.412,26.28" fill=":COLOR:"/>
          </g>
      </g></svg>`;

      // Add the first marker
      var parisIcon = new H.map.Icon(
        svgMarkup
          .replace(":COLOR:", sel ? "red" : "#1188dd")
          .replace(":TEXT:", "P")
      );

      const marker = markersOnMap.isMobile
        ? new H.map.Marker(o, { icon: parisIcon })
        : new H.map.Marker(o);
      marker.setData(markersPerPlace[p]);
      markersOnMap.markerGroup.addObject(marker);
    } else {
      const marker = new H.map.Marker(s);
      marker.setData(s);
      markersOnMap.markerGroup.addObject(marker);
      lats = lats + s.lat;
      lngs = lngs + s.lng;
      count += 1;
    }
  });
  const toRemove = current.filter(
    i => i.getData()[0] && found.indexOf(i.getData()[0].id) < 0
  );
  markersOnMap.markerGroup.removeObjects(toRemove);
  if (lats !== 0 && markersOnMap.needCenter) {
    //something changed + not in full select
    map.setCenter({ lat: lats / count, lng: lngs / count });
    markersOnMap.needCenter = false;
  }
}

export function clearMarkers() {
  if (!markersOnMap.markerGroup) {
    return;
  }
  markersOnMap.markerGroup.removeAll();
  if (markersOnMap.currentMarkers !== null) {
    markersOnMap.currentMarkers.forEach(m => ui.removeBubble(m));
  }
  markersOnMap.currentMarkers = [];
}

export function getCoordinates(address) {
  return new Promise((resolve, reject) => {
    var geocodingParams = {
      searchText: address
    };
    geocoder.geocode(
      geocodingParams,
      result => {
        if (!result.Response.View[0]) {
          reject("no result " + address);
          return;
        }
        var locations = result.Response.View[0].Result;
        if (!locations[0]) {
          reject("no result " + address);
          return;
        }
        var position = {
          lat: locations[0].Location.DisplayPosition.Latitude,
          lng: locations[0].Location.DisplayPosition.Longitude
        };
        resolve(position);
      },
      function(e) {
        reject(e);
      }
    );
  });
}

/* eslint-enable */
